import * as z from "zod";
import { USER_API_KEY_NAME_PREFIX } from "../apiKeyPrefix";
import { mutator } from "./mutator";

// A named API key that acts as the calling user, with their own access. Unlike
// a service account key it always expires: a credential that carries a person's
// full access shouldn't outlive a working day. There is no refresh — mint a new
// one.
export const USER_API_KEY_TTL_SECONDS = 24 * 60 * 60;

export const createUserApiKeySchema = z.object({
  id: z.string(),
  name: z.string(),
  start: z.string(),
  key: z.string(),
});

export const createUserApiKey = mutator({
  redactKeys: ["key"],
  schema: createUserApiKeySchema,
  resolve: {},
  permissions: {
    none: "a user is always allowed to mint a credential that acts as themselves, with exactly their own access",
  },
  // The `key` hash is written server-side only (see the server mutator) so it
  // never lands in the client's optimistic Zero cache.
  fn: async ({ tx, ctx, args: { id, name, start } }) => {
    const now = Date.now();
    await tx.mutate.apikey.insert({
      id,
      // Prefixed so the deprecated api-keys page filters it out; the member
      // modal strips the prefix for display.
      name: `${USER_API_KEY_NAME_PREFIX}${name}`,
      start,
      referenceId: ctx.userId,
      spaceId: null,
      serviceAccountId: null,
      enabled: true,
      expiresAt: now + USER_API_KEY_TTL_SECONDS * 1000,
      createdAt: now,
      updatedAt: now,
      tenantId: ctx.tenantId,
    });
  },
});
